import { IconButton, IconNotification, WithTooltip } from '@procurify/ui'

import { ApprovalReminderFormModal } from '@webapp/core/components/ApprovalReminderForm/ApprovalReminderFormModal'
import { type Approver } from '@webapp/core/entities/internal/Approver'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useApprovalReminderIconButton } from './useApprovalReminderIconButton'

export interface IApprovalReminderIconButtonProps {
  expenseId: number
  recipient: Approver
}

export const ApprovalReminderIconButton = ({
  expenseId,
  recipient,
}: IApprovalReminderIconButtonProps) => {
  const intl = useProcurifyIntl()

  const {
    states: { isModalOpen, modalTitle },
    methods: { openReminderFormModal, closeReminderFormModal },
    commands: { submitApprovalReminder },
  } = useApprovalReminderIconButton({ expenseId })

  return (
    <>
      <WithTooltip title={intl.formatMessage(messages.tooltipText)}>
        <IconButton
          iconComponent={<IconNotification />}
          aria-label={intl.formatMessage(messages.ariaLabel)}
          onClick={openReminderFormModal}
        />
      </WithTooltip>
      <ApprovalReminderFormModal
        open={isModalOpen}
        reference={modalTitle}
        recipient={recipient}
        onCancel={closeReminderFormModal}
        onSubmit={(values) =>
          submitApprovalReminder({ message: values.message })
        }
      />
    </>
  )
}
